(function () {
  'use strict';
  var cleanup = new WeakMap();
  function nodes(selector, root) {
    var result = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) result.unshift(root);
    return result;
  }
  function initProduct(section) {
    if (cleanup.has(section)) cleanup.get(section)();
    var controller = new AbortController();
    var on = function (target, name, fn) { target.addEventListener(name, fn, { signal: controller.signal }); };
    var quantity = section.querySelector('[data-order-quantity]');
    var select = section.querySelector('[data-variant-select]');
    var panel = section.querySelector('[data-artwork-panel]');
    var dock = section.querySelector('[data-order-dock]');
    var dockTotal = section.querySelector('[data-dock-total]');
    var panelVisible = false;
    function sync() {
      var choice = select ? select.selectedOptions[0] : section.querySelector('input[name="id"]');
      var valid = choice && choice.dataset.available === 'true' && (!quantity || quantity.validity.valid && Number(quantity.value) > 0);
      section.querySelectorAll('[data-print-help]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), window.location.href);
        url.searchParams.set('product', section.dataset.productName || '');
        url.searchParams.set('topic', link.dataset.helpTopic || 'artwork');
        if (select) url.searchParams.set('size', select.selectedOptions[0].textContent.trim());
        if (quantity && quantity.validity.valid) url.searchParams.set('quantity', quantity.value);
        else url.searchParams.delete('quantity');
        link.href = url.pathname + url.search + url.hash;
      });
      if (!dock) return;
      dock.hidden = !valid || panelVisible;
      var estimate = section.querySelector('[data-bulk-estimate]');
      var output = estimate && !estimate.hidden ? estimate.querySelector('[data-bulk-total]') : section.querySelector('[data-order-subtotal]');
      dockTotal.textContent = output ? output.textContent : section.querySelector('[data-product-price]')?.textContent || '';
      var dockLabel = section.querySelector('[data-dock-label]');
      if (dockLabel) dockLabel.textContent = !quantity ? section.dataset.dockApp : estimate && !estimate.hidden ? section.dataset.dockEstimated : section.dataset.dockListed;
    }
    on(section, 'change', sync); on(section, 'input', sync);
    on(section, 'click', function (event) {
      var jump = event.target.closest('[data-order-jump]');
      if (jump && quantity && !quantity.validity.valid) { event.preventDefault(); quantity.reportValidity(); }
    });
    var observer;
    if (dock && panel && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { panelVisible = entries[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -70px 0px', threshold: 0 });
      observer.observe(panel);
    }
    sync();
    cleanup.set(section, function () { controller.abort(); if (observer) observer.disconnect(); });
  }
  function initContext(root) {
    nodes('[data-inquiry-context]', root).forEach(function (box) {
      if (cleanup.has(box)) cleanup.get(box)();
      var controller = new AbortController();
      var params = new URL(window.location.href).searchParams;
      var product = params.get('product');
      var fields = [box.querySelector('[data-inquiry-product]'), box.querySelector('[data-inquiry-size]'), box.querySelector('[data-inquiry-quantity]')];
      if (product) {
        fields[0].value = product.slice(0,200);
        fields[1].value = (params.get('size') || '').slice(0,100);
        var q = params.get('quantity') || '';
        fields[2].value = /^[1-9][0-9]{0,6}$/.test(q) ? q : '';
        box.hidden = false;
      }
      var form = box.closest('form');
      var topic = form.querySelector('[name="contact[Topic]"]');
      var option = topic && Array.from(topic.options).find(function (entry) { return entry.dataset.topic === params.get('topic'); });
      if (option && !topic.value) option.selected = true;
      box.querySelector('[data-clear-inquiry]').addEventListener('click', function () { fields.forEach(function (field) { field.value = ''; }); box.hidden = true; }, { signal: controller.signal });
      cleanup.set(box, function () { controller.abort(); });
    });
  }
  function init(root) { nodes('[data-product-section]', root).forEach(initProduct); initContext(root); }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { nodes('[data-product-section],[data-inquiry-context]', event.target).forEach(function (node) { if (cleanup.has(node)) cleanup.get(node)(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
})();
